import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { GameProvider } from './GameContext';
import Layout from './Layout';
import { Home, About, Login } from './PageComponents';
import Vocabulary from './components/vocab/Vocabulary.jsx';
import GrammarTrainer from './components/grammar/GrammarTrainer.jsx';
import Lessons from './components/lessons/Lessons.jsx';
import { useAuth } from "react-oidc-context";

const PrivateRoute = ({ children }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }
  
  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }
  
  if (!auth.isAuthenticated) {
    navigate('/login');
    return null;
  }
  
  return children;
};

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    const clientId = "14lmp7lfhglhmg6d84446r1gv5";
    const logoutUri = "https://lingoppia.com";
    const cognitoDomain = "https://us-east-2uz9qrt6qo.auth.us-east-2.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  // Handle initial auth loading state
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }
  


  return (
    <GameProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout auth={auth} onSignOut={signOutRedirect} />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="login" element={<Login auth={auth} />} />
            {/* Protected routes */}
            <Route path="vocabulary" element={
              <PrivateRoute>
                <Vocabulary />
              </PrivateRoute>
            } />
            <Route path="grammar" element={
              <PrivateRoute>
                <GrammarTrainer />
              </PrivateRoute>
            } />
            <Route path="lessons" element={
              <PrivateRoute>
                <Lessons />
              </PrivateRoute>
            } />
          </Route>
        </Routes>
      </Router>
    </GameProvider>
  );
}

export default App;
